import React, { useCallback } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { TransformationSection } from '../components/TransformationSection';
import { WhatIsSection } from '../components/WhatIsSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { IncludesSection } from '../components/IncludesSection';
import { PriceSection } from '../components/PriceSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { OfferToast } from '../components/OfferToast';
export function Landing() {
  const scrollToPrice = useCallback(() => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  }, []);
  return <div className="w-full bg-crema font-sans text-tinta" data-id="element-236" data-mp="2ati6jcgu3ds">
      <Header onCTA={scrollToPrice} data-id="element-237" data-mp="3tgl5layuz1ww" />
      <main data-id="element-238" data-mp="3tfjx9e988tiv">
        <Hero onCTA={scrollToPrice} data-id="element-239" data-mp="3tes2g5ngeztn" />
        <PainSection data-id="element-240" data-mp="3peq4o7kuaqjn" />
        <TransformationSection data-id="element-241" data-mp="3pdybt4imn6x2" />
        <WhatIsSection data-id="element-242" data-mp="3pf9ojtu1vp0b" />
        <HowItWorksSection data-id="element-243" data-mp="3pgkthwz8f2t0" />
        <IncludesSection data-id="element-244" data-mp="3kg6ji9e2lisc" />
        <PriceSection onCTA={scrollToPrice} data-id="element-245" data-mp="3kgyh1pr89ql9" />
        <TestimonialsSection data-id="element-246" data-mp="3khzt9xjzcj4k" />
        <GuaranteeSection data-id="element-247" data-mp="l11kx0c96rtg" />
        <FAQSection data-id="element-248" data-mp="kz8cpglzrzjc" />
        <FinalCTASection onCTA={scrollToPrice} data-id="element-249" data-mp="l2mcqi76nwnm" />
      </main>
      <Footer data-id="element-250" data-mp="gzzg83zkhnk3" />
      <OfferToast data-id="element-251" data-mp="gzg9zkja4nlw" />
    </div>;
}